<div>
  <span class="date_date" [appCustomDate]="appCustomDate"></span>
  <span class="date_time" *ngIf="!params.dateWithoutTime">{{ date | date: "shortTime" }}</span>
</div>
